module.exports={
	"baseClass" : "js-carousel",
	"containerSelector" : ".js-carousel-wrapper",
	"items": 1,
	"nav": true,
	"navText": false,
	"dots": false,
	"loop": true
}